module.exports = __webpack_public_path__ + "static/img_3.7cec4a10.jpg";